import React from 'react';
import InlineSVG from 'react-inlinesvg';

function FJSvg(props) {
  const { src, ...restProps } = props;

  if (typeof src === 'function') {
    const SvgComponent = src;
    return <SvgComponent {...restProps} />;
  }

  const _props = {
    ...props,
    src: typeof src === 'string' ? src : src?.src,
  };

  return <InlineSVG {..._props} cacheRequests={true} />;
}

export default FJSvg;